import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import bootstrapClarity from 'clarity';
import { supportLegacyBrowsers } from 'common/utilities/BrowserHelpers';
import { getClarityProjectId, isClarityEnabled } from 'common/utilities/FlightSetting';
import { pageDataService } from 'common/utilities/PageDataService';
import TelemetryProvider from 'common/utilities/TelemetryProvider';
import { SW_VERSION } from 'serviceWorkers/Constants';
import { Workbox } from 'workbox-window';

import App from './App';

supportLegacyBrowsers();

const container = document.getElementById('app')!;
const root = createRoot(container);
root.render(<App />);

if ('serviceWorker' in navigator) {
  // eslint-disable-next-line i18next/no-literal-string
  const wb = new Workbox('/sw.js');

  wb.addEventListener('installed', () => {
    TelemetryProvider.Instance.trackEvent('swInstalled', { version: SW_VERSION });
    console.info(`Service worker installed: ${SW_VERSION}`);
  });

  wb.register()
    .then(async () => {
      console.info(`Service worker registered: ${SW_VERSION}`);

      if (!pageDataService.isDevEnvironment()) {
        wb.messageSW({
          type: 'CACHE_ASSETS',
        });
      }

      wb.messageSW({
        type: 'CACHE_OFFLINE',
      });
    })
    .catch((e) => {
      TelemetryProvider.Instance.trackException(e, 'swNotRegisteredException', { version: SW_VERSION });
      console.warn(`Service worker failed to register: ${SW_VERSION}`);
      console.error(e);
    });
} else {
  TelemetryProvider.Instance.trackException(
    {
      name: 'swUnsupportedException',
      message: 'Service worker not supported',
    },
    'swUnsupportedException',
    { version: SW_VERSION }
  );
  console.warn('Service worker not supported');
}

if (isClarityEnabled()) {
  bootstrapClarity(getClarityProjectId());
}
